module.exports = __webpack_public_path__ + "static/media/katy-perry-lose.b8fd27e3.jpg";